import React, { useEffect, useState } from 'react'
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import DailyShiftsForm from './components/DailyShiftsForm';
import PayRollReport from './components/PayrollReport';
import Employee from './components/Employee'
import HandleLogin from './components/HandleLogin';
import { useDispatch } from 'react-redux';
import { getUser } from './actions';
import { REDIRECT_URL } from './config';

function App() {
  const dispatch = useDispatch()
  const local_access_token = localStorage.getItem("access_token")
  const [access_token, setAccessToken] = useState(local_access_token)

  useEffect(() => {
    if (local_access_token === undefined || local_access_token === null || local_access_token === "null") {
      const at = getAccessTokenFromUrl()
      if (at !== null && at !== "null" && at !== "") {
          localStorage.setItem("access_token", at)
          setAccessToken(at)
          return
      } else {
        window.location="https://soto.auth.us-east-1.amazoncognito.com/login?client_id=1ntv7eg3d82d79mldq0tbtpod2&response_type=token&scope=email+openid+phone&redirect_uri=" + encodeURIComponent(REDIRECT_URL)
       }
    } else {
      dispatch(getUser())
    }
  }, [dispatch, local_access_token])
  return (
    <Router>
      {!(access_token === undefined || access_token === null || access_token === "null") ?(
      <Routes>
          <Route path="/" element={<DailyShiftsForm/>} />
          <Route path="/report" element={<PayRollReport/>} />
          <Route path="/employee" element={<Employee/>} />
          <Route path="/handle" element={<HandleLogin/>} />
      </Routes>)
      : (
      <Routes>
        <Route path="/handle" element={<HandleLogin/>}/>
      </Routes>
      ) 
    }
    </Router>
  )
}

const getAccessTokenFromUrl = () => {
  var pageUrl = window.location.href;
  pageUrl = pageUrl.toString()

  var paramIndex = pageUrl.indexOf("#")
  if (paramIndex === -1) {
      return null
  }
  var parameters = pageUrl.substring(paramIndex + 1)
  //console.log("App parameters: ", parameters)
  var accessToken = getParameter(parameters, "access_token=")
  return accessToken
}

const getParameter = (url, param) => {
  var urlVars = url.split('&')
  var returnValue;
  for (var i = 0; i < urlVars.length; i++) {
      var urlParam = urlVars[i]
      var index = urlParam.toString().indexOf("=")
      urlParam = urlParam.substring(0, index + 1)
      if (param === urlParam) {
          returnValue = urlVars[i].replace(param, "")
          i = urlVars.length
      }
  }
  return returnValue
}

export default App;
